(ns frontend.view.settings2.sso.model)

(def root-path [::state])

(def initialized?-key :initialized?)
(def initialized?-full-path (conj root-path initialized?-key))

(def loading-error?-key :loading-error?)
(def loading-error?-full-path (conj root-path loading-error?-key))

(def configs-key :configs)
(def configs-full-path (conj root-path configs-key))

(def form-config-key :form-config)
(def form-config-full-path (conj root-path form-config-key))

(def new-config?-key :new-config?)
(def new-config?-full-path (conj root-path new-config?-key))

(def delete-modal-key :delete-modal)
(def delete-modal-full-path (conj root-path delete-modal-key))

(def view-mode-key :view-mode)
(def view-mode-full-path (conj root-path view-mode-key))

(def selected-config-id-key :selected-config-id)
(def selected-config-id-full-path (conj root-path selected-config-id-key))

(def login-path-conflict?-key :login-path-conflict?)
(def login-path-conflict?-full-path (conj root-path login-path-conflict?-key))

(def touched-fields-key :touched-fields)
(def touched-fields-full-path (conj root-path touched-fields-key))

(def show-all-errors-key :show-all-errors?)
(def show-all-errors-full-path (conj root-path show-all-errors-key))

(defn create-default-form-config
  [existing-configs]
  {:login-page-config/name ""
   :login-page-config/path ""
   :login-page-config/sso-login-methods #{}
   :default-config? (empty? existing-configs)})

;; Helper functions for SSO configuration
(defn has-azure-sso?
  [config]
  (some #{:azure} (:login-page-config/sso-login-methods config)))

(defn has-saml-sso?
  [config]
  (some #{:saml} (:login-page-config/sso-login-methods config)))

